import { v4 as uuidv4 } from 'uuid';

import { IKnmErpErvkFormObject } from '../../KnmErpSubjectModule/interfaces/IKnmErpErvkFormObject';
import { createDistrictSelectOption } from '../../../CorePackage/CatalogsModule/common/createDistrictSelectOption';
import { getDictionarySelectOptionWithState } from '../../../CorePackage/DictionariesModule/common/getDictionarySelectOptionWithState';
import { DictionaryUUIDsEnum } from '../../../CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { IKnmErpObjectErvk } from '../../../APIPackage/KnmModule/interfaces/IKnmErpObjectErvk';
import { getAdminFetchSettings } from '../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { getKnmDataCreated } from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { IDictionaryValue } from '../../../APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { ISupervisionType } from '../../../APIPackage/DictionariesModule/interfaces/ISupervisionType';
import { getDictionariesItemValueData } from '../../../CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { createDictionarySupervisionTypeExtendedSelectOption } from '../../../CorePackage/DictionariesModule/common/createDictionarySupervisionTypeSelectOption';
import { IKnmErpObjectSupervision } from '../../KnmErpSubjectModule/interfaces/IKnmErpObjectSupervision';

export const getInitialErpObjectErvk = (state: IRootState, object: IKnmErpObjectErvk) => {
  const settings = getAdminFetchSettings(state);
  const isUseTransferringAuthorities = isLaterThanAdminSetting(
    getKnmDataCreated(state),
    settings,
    AdminSettingCodesEnum.TRANSFERRING_AUTHORITIES_4_1_22_STARTS_FROM,
  );

  const objectTypeSelectOption = object.objectType?.dictId
    ? getDictionarySelectOptionWithState<DictionaryUUIDsEnum.SUBJECT_TYPE>(
        state,
        object.objectType?.dictId,
        object.objectType?.dictVersionId,
      )
    : undefined;

  const riskCategorySelectOption = object.riskCategory?.dictId
    ? getDictionarySelectOptionWithState<DictionaryUUIDsEnum.RISK_CATEGORY>(
        state,
        object.riskCategory?.dictId,
        object.riskCategory?.dictVersionId,
      )
    : undefined;

  const objectFormSupervisions: IKnmErpObjectSupervision[] = [];

  object.supervisions
    ?.filter(supervision => supervision.supervisionType.dictId)
    ?.forEach(supervision => {
      // @ts-ignore
      const dictionaryValue: IDictionaryValue<ISupervisionType> = getDictionariesItemValueData(
        state,
        supervision.supervisionType?.dictId,
        supervision.supervisionType?.dictVersionId,
      );

      if (dictionaryValue && dictionaryValue.value) {
        objectFormSupervisions.push({
          listId: supervision.numGuid || uuidv4(),
          supervision: createDictionarySupervisionTypeExtendedSelectOption(
            supervision.supervisionType?.dictId,
            dictionaryValue,
            isUseTransferringAuthorities,
          ),
        });
      }
    });

  const formObject: IKnmErpErvkFormObject = {
    address: object.address ?? undefined,
    addressFns: object.addressFns ?? undefined,
    autocomplete: typeof object.autocomplete === 'boolean' ? object.autocomplete : undefined,
    dateCreate: object.dateCreate ?? undefined,
    ervkId: object.ervkId ?? undefined,
    ervkNumber: object.ervkNumber ?? undefined,
    fiasRegion: (object.fiasRegion && createDistrictSelectOption(object.fiasRegion)) ?? undefined,
    geolocation: object.geolocation ?? undefined,
    houseGuid: object.houseGuid ?? undefined,
    guid: object.guid,
    isAddressHazard: object.isAddressHazard,
    isErrorFiasValue: undefined,
    isNew: false,
    listId: object.guid,
    manualAddress: object.manualAddress ?? undefined,
    name: object.name ?? undefined,
    notInFIAS: object.notInFIAS ?? undefined,
    objectKind: undefined,
    objectSubKind: undefined,
    objectType: objectTypeSelectOption,
    organizationErvkId: object.organizationErvkId ?? undefined,
    region: (object.region && createDistrictSelectOption(object.region)) ?? undefined,
    regionName: object.regionName ?? undefined,
    riskCategory: riskCategorySelectOption,
    roomGuid: object.roomGuid ?? undefined,
    steadGuid: object.steadGuid ?? undefined,
    streetGuid: object.streetGuid ?? undefined,
    supervisions: objectFormSupervisions,
  };

  return formObject;
};
